import React from "react";
import { Grid2 } from "@mui/material";
import { User } from "../../../interfaces/entities/user";
import { OwnerCardView } from "../employeeCardView/ownerCardView";
import { getRoleLabel } from "../../../utils/userRoleLabel";

interface EmployeeListViewProps {
  users: User[];
  companyId: string;
}

export const OwnerListView: React.FC<EmployeeListViewProps> = ({ users, companyId }) => {

  return (
    <>
      <Grid2 container spacing={2} sx={{ padding: 2 }}>
        {users.map((user) => {
          const roleLabel = getRoleLabel(user.role);
          return (
            <Grid2 key={user.id} size={{ xs: 12, sm: 6, md: 4, lg: 2 }}>
              <OwnerCardView
                userData={user}
                companyId={companyId}
                roleLabel={roleLabel}
              />
            </Grid2>
          );
        })}
      </Grid2>
    </>
  );
};

